export type PackagePricing = {
    price: number
    originalPrice?: number | null
}

// The server resolves an early bird deadline before it sends a package down, so an original price
// above the effective price is exactly what "this ticket is on early bird pricing" means.
export const isEarlyBirdPricing = (pkg: PackagePricing): boolean =>
    typeof pkg.originalPrice === 'number' && pkg.originalPrice > pkg.price

// The currency formatter and the localized label are injected so this stays usable from web, admin
// and mobile, each of which formats prices differently (tax-aware, plain, HUF-only).
export const formatPackagePriceLabel = (
    pkg: PackagePricing,
    format: (value: number) => string,
    earlyBirdLabel: string,
): string =>
    isEarlyBirdPricing(pkg) ? `${format(pkg.price)} (${earlyBirdLabel})` : format(pkg.price)
